import * as angular from "angular";
import * as _ from "lodash";
import {IController, IScope} from "angular";
import {BillingOrder} from "../../models/billing-order.model";
import {LocationType} from "../../../commons/types/location.type";
import {BillingOrderStatusType} from "../../types/billing-order-status.type";
import {SplitService} from "../../../commons/services/split-service.service";

export class BillingOrdersTableRowCtrl implements IController {

  columns: any;
  billingOrderId: string;
  billingOrder: BillingOrder;
  isSelected: boolean;
  isActive: boolean;
  isShowEdiStatusCol: boolean;
  onOrderClick: Function;
  onSelect: Function;
  onEdit: Function;
  onEditOrder: Function;
  onConsolidate: Function;
  onRemoveConsolidate: Function;
  onFilterByType: Function;


  public canOpenPanel: any;
  public locationTypes: typeof LocationType = LocationType;
  public billingOrderStatusType: typeof BillingOrderStatusType = BillingOrderStatusType;

  public agentsNames: string[];
  public resourcesNames: string[];

  constructor(private IAMPermissions, private $billingOrders, private $scope: IScope, private splitService: SplitService) {
  }

  $onInit() {

    if (this.billingOrderId) {
      this._bindStepToCtrl();
    }
  }

  $onChanges(changes) {
    if(changes.billingOrderId && !changes.billingOrderId.isFirstChange()){
      this._bindStepToCtrl();
    }
  }

  public bindOnChanges(changes: angular.IOnChangesObject) {
    if(changes.billingOrderId && !changes.billingOrderId.isFirstChange()){
      this._bindStepToCtrl();
    }
  }

  onRowSelect() {
    this.canOpenPanel = this.IAMPermissions.hasPermission('billingOrders.get');
    if (this.canOpenPanel) {
      this.onOrderClick({billingOrder: this.billingOrder})
    }
  }

  private _bindStepToCtrl() {
    if (this.billingOrderId) {
      this.$billingOrders(this.billingOrderId).$bindCtrlToId(this.$scope, this, 'billingOrder', 'billingOrderId');
    }
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingOrdersTableRow', {
    require: {
      billingOrdersTableCtrl: '^billingOrdersTable'
    },
    bindings: {
      columns: '<',
      billingOrderId: '<',
      billingOrder: '<',
      isSelected: '<?',
      isActive: '<?',
      isShowEdiStatusCol: '<',
      onOrderClick: '&',
      onSelect: '&',
      onEdit: '&',
      onEditOrder: '&',
      onConsolidate: '&',
      onRemoveConsolidate: '&',
      onFilterByType: '&'
    },
    template: require('./billing-orders-table-row.html').default,
    controller: BillingOrdersTableRowCtrl
  });
